import LandingNotification from 'components/marketingSite/landing/LandingNotification';
import { useI18n } from 'hooks/useI18n';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { Element } from 'react-scroll';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { StyledPage } from './Page.styled';
import { PageProps } from './Page.types';
import { PageDrawerContextProvider } from './PageDrawerContext';
import Topbar from './topbar/Topbar';

const HEADER_HEIGHT = 64;

export const Footer = dynamic(() => import('./footer/Footer'), {
  ssr: false
});

export const PageNav = dynamic(() => import('./pageNav/PageNav'), {
  ssr: false
});

export const ScrollTop = dynamic(() => import('./scrollTop/ScrollTop'), {
  ssr: false
});

const MarkdownComponent = dynamic(
  () => import('components/shared/MarkdownComponent'),
  { ssr: false }
);

const Page: React.FC<PageProps> = ({
  children,
  offerFooter,
  sections,
  className,
  pageVariant,
  filters = <></>,
  hasScrollTop,
  topBarTransparent,
  noTopBar,
  noFooter,
  onDrawerClose,
  customFooter,
  bannerText
}) => {
  const { t } = useI18n('common');

  const [isHeadroomPinned, setIsHeadroomPinned] = useState(false);

  function headroomPinned(): void {
    setIsHeadroomPinned(true);
    document.documentElement.style.setProperty(
      '--header-offset',
      `${HEADER_HEIGHT}px`
    );
  }

  function headroomUnpinned(): void {
    setIsHeadroomPinned(false);
    document.documentElement.style.setProperty('--header-offset', '0px');
  }

  return (
    <PageDrawerContextProvider onDrawerClose={onDrawerClose}>
      <StyledPage
        variant={pageVariant}
        className={`${isHeadroomPinned ? 'is-headroom-pinned' : ''}`}
      >
        {!!bannerText && (
          <LandingNotification>
            <MarkdownComponent content={bannerText} />
          </LandingNotification>
        )}
        {!noTopBar && (
          <Topbar
            topBarTransparent={topBarTransparent}
            isHeadroomPinned={headroomPinned}
            isHeadroomUnpinned={headroomUnpinned}
          />
        )}

        <main className={className}>
          <Element id="pageTop" name="pageTop">
            {sections && sections.length > 0 && (
              <PageNav
                sections={sections}
                prevLabel={t('pageNav.prev')}
                nextLabel={t('pageNav.next')}
                navLabel={t('pageNav.label')}
              />
            )}

            {children}
          </Element>
        </main>

        {filters}

        {offerFooter && (
          <Footer offerFooter={offerFooter} hasScrollTop={hasScrollTop} />
        )}

        {customFooter && <>{customFooter}</>}

        {!customFooter && !offerFooter && !noFooter && <Footer />}

        {hasScrollTop && <ScrollTop />}
      </StyledPage>
    </PageDrawerContextProvider>
  );
};

export default Page;
